import { gql } from "@apollo/client"

const GET_ORGANIZATIONS_IDSTAMP = gql`
  query Organizations($staff_id: ID!, $organization_id: ID!) {
    organizations: statsOrganizationsByUid(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      organization_id
      organization_name
      organization_status
      current_staff_users
      current_participants
      current_programs
      current_locations
      organization_id_stamp
    }
  }
`

export { GET_ORGANIZATIONS_IDSTAMP }
